import React, { useState } from "react";
import { useParams } from "react-router-dom";
import AppLeftSideBar from "../../components/SideBar/AppLeftSideBar";
import AuditPerforms from "./AuditPerforms";
import AuditExportRuns from "./AuditExportRuns";
import AuditConfig from "./AuditConfig";
import "../Monitor/monitor.css";
import "./audit.css";

const TABS = [
  { key: "performs", label: "Performs" },
  { key: "exports", label: "Exports" },
  { key: "settings", label: "Settings" }
];

// Single Audit page with tabs. Only the active tab's component is mounted, so
// each tab fetches its data lazily (on first open), not up front.
const AuditHome = () => {
  const { orgId } = useParams();
  const [tab, setTab] = useState("performs");

  return (
    <div className="application_container">
      <AppLeftSideBar type="app" />
      <div className="h_100 d_flex flex_column w_100 p_3" style={{ gap: 12, minHeight: 0 }}>
        <div className="d_flex align_center justify_between">
          <h2>Audit</h2>
        </div>

        <div className="audit_tabs">
          {TABS.map((t) => (
            <button key={t.key} className={`audit_tab ${tab === t.key ? "active" : ""}`} onClick={() => setTab(t.key)}>
              {t.label}
            </button>
          ))}
        </div>

        {tab === "performs" && <AuditPerforms embedded orgId={orgId} />}
        {tab === "exports" && <AuditExportRuns embedded orgId={orgId} />}
        {tab === "settings" && <AuditConfig embedded orgId={orgId} />}
      </div>
    </div>
  );
};

export default AuditHome;
